// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"c16caf1ea4f33c8855d4","522":"11ac0d5d861a9610b9c1"}[chunkId] + ".js";
};